import { SortTabsProps } from "./interface";
import { SortTabButton, SortTabsWrapper } from "./styled.components";

const SortTabs = (props: SortTabsProps) => {
  const { tabs, selectedTab, onTabChanged } = props;

  return (
    <SortTabsWrapper>
      {tabs.map((tab, index) => (
        <SortTabButton
          key={tab.label}
          type="button"
          selected={selectedTab === index}
          disabled={tab.disabled}
          onClick={() => !tab.disabled && onTabChanged(index)}
        >
          {tab.label}
        </SortTabButton>
      ))}
    </SortTabsWrapper>
  );
};

export default SortTabs;
